export const BACKGROUND_CHECK_APP_PENDING = "app-pending";
export const BACKGROUND_CHECK_APP_READY = "app-ready";
export const BACKGROUND_CHECK_CANCELED = "canceled";
export const BACKGROUND_CHECK_CLIENT_MESSAGE = "client message";
export const BACKGROUND_CHECK_COMPLETE = "complete";
export const BACKGROUND_CHECK_DISPATCHED_QC = "dispatched qc";
export const BACKGROUND_CHECK_DRAFT = "draft";
export const BACKGROUND_CHECK_END_USER = "end-user";
export const BACKGROUND_CHECK_INTERNAL_ERROR = "internal-error";
export const BACKGROUND_CHECK_NEW = "new";
export const BACKGROUND_CHECK_PENDING = "pending";
export const BACKGROUND_CHECK_PENDING_REVIEW = "pending review";
export const BACKGROUND_CHECK_PRE_PULL = "pre-pull";
export const BACKGROUND_CHECK_QA_REVIEW = "qa review";
export const BACKGROUND_CHECK_ARCHIVED = "archived";

export const BACKGROUND_CHECK_STATUS_NOT_STARTED = [
  BACKGROUND_CHECK_APP_READY,
  BACKGROUND_CHECK_DRAFT,
  BACKGROUND_CHECK_NEW,
  BACKGROUND_CHECK_PRE_PULL
];

export const BACKGROUND_CHECK_STATUS_IN_PROGRESS = [
  BACKGROUND_CHECK_PENDING,
  BACKGROUND_CHECK_PENDING_REVIEW,
  BACKGROUND_CHECK_APP_PENDING,
  BACKGROUND_CHECK_QA_REVIEW,
  BACKGROUND_CHECK_DISPATCHED_QC
];

export const BACKGROUND_CHECK_STATUS_CANDIDATE_REQUIRED = [
  BACKGROUND_CHECK_END_USER,
  BACKGROUND_CHECK_CLIENT_MESSAGE
];

export const BACKGROUND_CHECK_STATUS_COMPLETED_GOOD = [
  BACKGROUND_CHECK_COMPLETE,
  BACKGROUND_CHECK_ARCHIVED
];


export const BACKGROUND_CHECK_STATUS_ERROR = [
  BACKGROUND_CHECK_CANCELED,
  BACKGROUND_CHECK_INTERNAL_ERROR,
];
